import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_app/settings/documents')({
  component: () => <Outlet />,
})
